exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hiprint-test[data-v-2a04db0a] {\n  padding: 20px;\n}\n.preview-container[data-v-2a04db0a] {\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  padding: 20px;\n  min-height: 200px;\n  background: #fff;\n}\n", ""]);

// exports
